import { useEffect, useState } from "react";

const API_BASE = "https://api.soscontrol.it";

function getTokenFromUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.get("token");
}

function stripTokenFromUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete("token");
  window.history.replaceState({}, "", url.toString());
}

function normRole(r) {
  return String(r || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " "); // normalizza spazi multipli
}

function hasContabilitaAccess(me) {
  const roles = (me?.roles || []).map(normRole);

  const allowed = new Set([
    "developer",
    "admin",
    "tesoriere",
    "segretario",
    "aiuto tesoriere",
    "aiuto segretario",
    "contabilita",
  ]);

  return roles.some((r) => allowed.has(r));
}

export function GateContabilita({ children }) {
  const [status, setStatus] = useState("loading");
  const [reason, setReason] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const urlToken = getTokenFromUrl();
        const savedToken = localStorage.getItem("sos_token");
        const token = urlToken || savedToken;

        if (!token) {
          setReason("Manca il token: accedi da auth.soscontrol.it.");
          setStatus("ko");
          return;
        }

        // salva token e pulisci URL
        if (urlToken) {
          localStorage.setItem("sos_token", urlToken);
          stripTokenFromUrl();
        }

        const res = await fetch(`${API_BASE}/api/me`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          localStorage.removeItem("sos_token");
          localStorage.removeItem("sos_me");
          setReason("Sessione non valida: rifai login su auth.soscontrol.it.");
          setStatus("ko");
          return;
        }

        const me = await res.json();

        if (!hasContabilitaAccess(me)) {
          const roles = (me?.roles || []).map(normRole).join(", ");
          setReason(`Non hai i permessi per Contabilità. Ruoli: ${roles || "-"}`);
          setStatus("ko");
          return;
        }

        localStorage.setItem("sos_me", JSON.stringify(me));
        setStatus("ok");
      } catch {
        setReason("Errore di rete/verifica.");
        setStatus("ko");
      }
    })();
  }, []);

  if (status === "loading") return <div style={{ padding: 24 }}>Verifica accesso...</div>;

  if (status === "ko") {
    return (
      <div style={{ padding: 24 }}>
        <h2>Accesso negato</h2>
        <p>{reason}</p>
        <a href="https://auth.soscontrol.it">Vai al login</a>
      </div>
    );
  }

  return <>{children}</>;
}
